// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3gXX-","productName":"Table_productName__vdXGt"};